import moment from 'moment'
import * as jsPDF from 'jspdf'
import * as three from '@/components/Canvas/threeMain'
import QRCode from 'qrcode'
import { ParseCode } from '@/components/Code/CodeValidator'
import './swiss-721-bt'
import './swiss-721-bold'
import './swiss-721-thin'
// http://raw.githack.com/MrRio/jsPDF/master/docs/
// https://www.giftofspeed.com/base64-encoder/

let _doc
const _title = 'Roche_Bobois'
// https://www.papersizes.org/a-sizes-in-pixels.htm
const _docWidth = 877
const _docHeight = 620
let _tableData
let w
let h
let page

export default {
  async CreatePDF (tableData) {
    _tableData = tableData
    _doc = new jsPDF({ // eslint-disable-line
      orientation: 'landscape',
      unit: 'px',
      format: [_docWidth, _docHeight]
    })
    w = _doc.internal.pageSize.width
    h = _doc.internal.pageSize.height
    page = 0
    page++
    await this.PageOne()
    _doc.addPage()
    page++
    await this.PageTwo()
    _doc.addPage()
    page++
    await this.PageThree()
    _doc.save(_title + String('_' + moment() + '.pdf'))
  },
  async PageOne () {
    await this.InsertTemplate()
    const img = new Image()
    img.src = 'assets/Roche_Corail_Render.jpg'
    _doc.addImage(img, 'JPG', w * 0.04, h * 0.179, w * 0.92, h * 0.761)
  },
  async PageTwo () {
    await this.InsertTemplate()
    const img = new Image()
    img.src = 'assets/Xtreee_01.jpg'
    _doc.addImage(img, 'JPG', w * 0.482, h * 0.201, w * 0.476, h * 0.491)
    img.src = 'assets/Xtreee_02.jpg'
    _doc.addImage(img, 'JPG', w * 0.743, h * 0.71, w * 0.217, h * 0.20)
    img.src = 'assets/Xtreee_03.jpg'
    _doc.addImage(img, 'JPG', w * 0.482, h * 0.711, w * 0.244, h * 0.20)
    _doc.setFontSize(10)
    _doc.setFont('swiss-721-regular', 'normal')
    const spacing = _doc.getFontSize()
    let trail = h * 0.201 + spacing
    const description = _doc.splitTextToSize(_tableData.wordingDescription, w * 0.4)
    for (let i = 0; i < description.length; i++) {
      _doc.text(description[i], w * 0.04, trail)
      trail += spacing
    }
    _doc.setFont('swiss-721-bold', 'bold')
    // _doc.text(_tableData.wordingVideo + ':', w * 0.04, h * 0.875)
    img.src = 'assets/YT.png'
    _doc.addImage(img, 'PNG', w * 0.04, h * 0.889, w * 0.031, h * 0.031)
    _doc.setFontSize(12)
    const url = _tableData.wordingUrl
    const length = ((_doc.getStringUnitWidth(url) * _doc.internal.getFontSize()) / _doc.internal.scaleFactor) / _doc.internal.pageSize.width
    _doc.text(url, w * 0.08, h * 0.91)
    // _doc.line(w * 0.08, h * 0.915, w * (0.08 + length), h * 0.915)
  },
  async PageThree () {
    await this.InsertTemplate()
    await this.AddNewImage(three.TakeScreenShot(w * 0.31, h * 0.388, 'top'), w * 0.31, h * 0.388, w * 0.06, h * 0.156)
    await this.AddNewImage(three.TakeScreenShot(w * 0.593, h * 0.388, 'persp'), w * 0.595, h * 0.388, w * 0.36, h * 0.156)
    await this.AddNewImage(three.TakeScreenShot(w * 0.31, h * 0.177, 'left'), w * 0.31, h * 0.177, w * 0.06, h * 0.566)
    await this.AddNewImage(three.TakeScreenShot(w * 0.14, h * 0.177, 'front'), w * 0.14, h * 0.177, w * 0.357, h * 0.566)
    await this.AddNewImage(three.TakeScreenShot(w * 0.29, h * 0.177, 'right'), w * 0.29, h * 0.177, w * 0.5, h * 0.566)
    await this.AddNewImage(three.TakeScreenShot(w * 0.16, h * 0.177, 'back'), w * 0.16, h * 0.177, w * 0.794, h * 0.566)
    _doc.setFont('swiss-721-regular', 'normal')
    _doc.setFontSize(12)
    _doc.setTextColor('000000')
    _doc.text(_tableData.wordingPerspective, w * 0.616, h * 0.536)
    this.VerticalDimensionLine(73, '28.7"', h * 0.611, h * 0.711, w * 0.041)
    switch (_tableData.id) {
      case 'A':
        this.VerticalDimensionLine(160, '63"', h * 0.236, h * 0.461, w * 0.041)
        this.HorizontalDimensionLine(160, '63"', w * 0.135, w * 0.295, h * 0.54)
        this.HorizontalDimensionLine(75, '29.5"', w * 0.178, w * 0.252, h * 0.731)
        this.HorizontalDimensionLine(75, '29.5"', w * 0.39, w * 0.462, h * 0.731)
        break
      case 'B':
        this.VerticalDimensionLine(190, '74.8"', h * 0.216, h * 0.481, w * 0.041)
        this.HorizontalDimensionLine(190, '74.8"', w * 0.118, w * 0.309, h * 0.54)
        this.HorizontalDimensionLine(85, '33.4"', w * 0.17, w * 0.255, h * 0.731)
        this.HorizontalDimensionLine(85, '33.4"', w * 0.385, w * 0.47, h * 0.731)
        break
      case 'C':
        this.VerticalDimensionLine(120, '47.2"', h * 0.265, h * 0.434, w * 0.041)
        this.HorizontalDimensionLine(220, '86.6"', w * 0.105, w * 0.325, h * 0.54)
        this.HorizontalDimensionLine(90, '35.4"', w * 0.17, w * 0.258, h * 0.731)
        this.HorizontalDimensionLine(45, '17.7"', w * 0.405, w * 0.45, h * 0.731)
        break
      case 'D':
        this.VerticalDimensionLine(120, '47.2"', h * 0.265, h * 0.434, w * 0.041)
        this.HorizontalDimensionLine(250, '98.4"', w * 0.089, w * 0.339, h * 0.54)
        this.HorizontalDimensionLine(100, '39.3"', w * 0.165, w * 0.262, h * 0.731)
        this.HorizontalDimensionLine(45, '17.7"', w * 0.405, w * 0.448, h * 0.731)
        break
      case 'E':
        this.VerticalDimensionLine(120, '47.2"', h * 0.265, h * 0.434, w * 0.041)
        this.HorizontalDimensionLine(280, '110.2"', w * 0.08, w * 0.35, h * 0.54)
        this.HorizontalDimensionLine(115, '45.2"', w * 0.159, w * 0.269, h * 0.731)
        this.HorizontalDimensionLine(45, '17.7"', w * 0.405, w * 0.448, h * 0.731)
        break
    }
    this.AddLabel('1', w * 0.215, h * 0.51)
    this.AddLabel('2', w * 0.062, h * 0.35)
    this.AddLabel('3', w * 0.215, h * 0.19)
    this.AddLabel('4', w * 0.372, h * 0.35)
    this.AddLabel('1', w * 0.213, h * 0.77)
    this.AddLabel('2', w * 0.428, h * 0.77)
    this.AddLabel('3', w * 0.645, h * 0.77)
    this.AddLabel('4', w * 0.873, h * 0.77)
    _doc.setFont('swiss-721-bold', 'bold')
    _doc.setFontSize(8)
    _doc.setTextColor('000000')
    _doc.text(_tableData.wordingProcess, w * 0.139, h * 0.857)
    _doc.setFont('swiss-721-regular', 'normal')
    _doc.text(_tableData.wordingCode + ':', w * 0.139, h * 0.911)
    _doc.text(_tableData.wordingCodeUrl + ':', w * 0.139, h * 0.937)
    const code = ParseCode()
    const url = this.GetUrl(code)
    let codeSpaced = ''
    for (let i = 0; i < code.length; i++) {
      codeSpaced += code[i]
      if (i > 0 && (i + 1) % 4 === 0) {
        codeSpaced += ' '
      }
    }
    _doc.setFont('swiss-721-bold', 'bold')
    _doc.text(codeSpaced, w * 0.253, h * 0.911)
    _doc.text(url, w * 0.253, h * 0.937)
    await this.GenerateQRCode(url)
    _doc.setTextColor('7c796f')
    _doc.setFontSize(15)
    _doc.text(_tableData.wordingPersonalization + ': ', w * 0.55, h * 0.15)
    _doc.text(_tableData.name, w * 0.55, h * 0.18)
  },
  AddLabel (text, x, y) {
    _doc.setFont('swiss-721-thin', 'thin')
    _doc.setFontSize(8)
    _doc.setTextColor('FFFFFF')
    _doc.setFillColor(0, 0, 0)
    _doc.circle(x, y, 5, 'F')
    const len = this.GetTextWidth(text)
    const hei = _doc.getFontSize()
    _doc.text(text, x - len / 2, y + hei / 4)
  },
  HorizontalDimensionLine (dimensionCM, dimensionImp, x1, x2, y) {
    _doc.setFont('swiss-721-thin', 'thin')
    _doc.setFontSize(6)
    _doc.setTextColor('000002')
    const dimCM = dimensionCM.toString() + ' cm'
    const dimImp = dimensionImp
    const spacing = 5
    const d = Math.max(this.GetTextWidth(dimCM), this.GetTextWidth(dimImp))
    const l = x2 - x1
    const breakpoint = x1 + ((l - d - spacing) / 2)
    _doc.line(x1, y, breakpoint, y)
    _doc.line(breakpoint + d + spacing, y, x2, y)
    _doc.line(x1, y - spacing / 2, x1, y + spacing / 2)
    _doc.line(x2, y - spacing / 2, x2, y + spacing / 2)
    if (_tableData.lang === 'en-US') {
      _doc.text(dimImp, breakpoint + spacing / 2 + (d - this.GetTextWidth(dimImp)) / 2, y - 1)
      _doc.text(dimCM, breakpoint + spacing / 2, y + _doc.getFontSize() - 2)
    } else {
      _doc.text(dimCM, breakpoint + spacing / 2, y - 1)
      _doc.text(dimImp, breakpoint + spacing / 2 + (d - this.GetTextWidth(dimImp)) / 2, y + _doc.getFontSize() - 2)
    }
  },
  VerticalDimensionLine (dimensionCM, dimensionImp, y1, y2, x) {
    _doc.setFont('swiss-721-thin', 'thin')
    _doc.setFontSize(6)
    _doc.setTextColor('000002')
    const dimCM = dimensionCM.toString() + ' cm'
    const dimImp = dimensionImp
    const spacing = 5
    const d = Math.max(this.GetTextWidth(dimCM), this.GetTextWidth(dimImp))
    const l = y2 - y1
    const breakpoint = y1 + ((l - d - spacing) / 2)
    _doc.line(x, y1, x, breakpoint)
    _doc.line(x, breakpoint + d + spacing, x, y2)
    _doc.line(x - spacing / 2, y1, x + spacing / 2, y1)
    _doc.line(x - spacing / 2, y2, x + spacing / 2, y2)
    if (_tableData.lang === 'en-US') {
      _doc.text(x - 1, breakpoint + d + spacing / 2 - (d - this.GetTextWidth(dimImp)) / 2, dimensionImp, null, 90)
      _doc.text(x + _doc.getFontSize() - 3, breakpoint + d + spacing / 2, dimensionCM.toString() + ' cm', null, 90)
    } else {
      _doc.text(x - 1, breakpoint + d + spacing / 2, dimensionCM.toString() + ' cm', null, 90)
      _doc.text(x + _doc.getFontSize() - 3, breakpoint + d + spacing / 2 - (d - this.GetTextWidth(dimImp)) / 2, dimensionImp, null, 90)
    }
  },
  GetUrl (code) {
    // const getUrl = window.location
    const baseUrl = 'https://resources.roche-bobois.com/corail/index.html'
    const res = baseUrl + '?params=' + code
    return res
  },
  async GenerateQRCode (url) {
    const u = await QRCode.toDataURL(url)
    _doc.addImage(u, w * 0.783, h * 0.83, w * 0.089, h * 0.126)
  },
  async InsertTemplate () {
    _doc.setFillColor(0, 0, 0)
    _doc.rect(w * 0.85, h * 0.048, w, h * 0.05, 'F')
    _doc.line(0, h * 0.098, w * 1, h * 0.098)
    const img = new Image()
    img.src = 'assets/Roche_Logo_White.png'
    _doc.addImage(img, 'PNG', w * 0.855, h * 0.059, w * 0.12, h * 0.03)
    _doc.setFontSize(25)
    _doc.setTextColor('7c796f')
    _doc.setFont('swiss-721-bold', 'bold')
    _doc.setTextColor('000002')
    const name = 'CORAIL'
    const spacing = this.GetTextWidth(name)
    _doc.text(name, w * 0.04, h * 0.09)
    _doc.setFontSize(25)
    _doc.setTextColor('867d6e')
    _doc.text(_tableData.wordingDiningTables, w * 0.06 + spacing, h * 0.09)
    _doc.setTextColor('7c796f')
    _doc.setFont('swiss-721-regular', 'normal')
    _doc.setFontSize(10)
    _doc.text(_tableData.wordingDesign, w * 0.04, h * 0.12)
  },
  GetTextCenterPos (text) {
    return (w - (_doc.getStringUnitWidth(text) * _doc.internal.getFontSize() / _doc.internal.scaleFactor)) / 2
  },
  GetTextWidth (string) {
    return _doc.getStringUnitWidth(string) * _doc.internal.getFontSize() / _doc.internal.scaleFactor
  },
  async AddNewImage (path, boundingBoxWidth, boundingBoxHeight, left, top) {
    const buff = path
    const size = await this.GetImageOriginalSize(buff)
    const fitSize = this.GetImageSizeToFit(size, boundingBoxWidth, boundingBoxHeight)
    const img = this.PurifyBase64(buff)
    _doc.addImage(img, this.GetImageExtension(path), left + (boundingBoxWidth - fitSize.x) / 2, top + (boundingBoxHeight - fitSize.y) / 2, fitSize.x, fitSize.y)
  },
  async GetImageOriginalSize (url) {
    return new Promise((resolve, reject) => {
      const img = new Image()
      img.onload = function () {
        resolve({ x: this.width, y: this.height })
      }
      img.src = url
    })
  },
  GetImageSizeToFit (originalSize, newWidth, newHeight) {
    const ratioA = originalSize.x / originalSize.y
    const ratioB = newWidth / newHeight
    if (ratioA > ratioB) {
      return { x: newWidth, y: (newWidth / originalSize.x) * originalSize.y }
    } else {
      return { x: (newHeight / originalSize.y) * originalSize.x, y: newHeight }
    }
  },
  GetImageExtension (path) {
    return path.split('?')[0].split('.').pop()
  },
  PurifyBase64 (img) {
    img = img.replace('data:application/octet-stream;base64,', '')
    img = img.replace('data:binary/octet-stream;base64,', '')
    img = img.replace('data:text/html;base64,', '')
    return img
  },
  async GetBase64ImageFromUrl (imageUrl) {
    let res
    try {
      res = await fetch(imageUrl)
    } catch (e) {
      console.log(e)
    }
    const blob = await res.blob()
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.addEventListener(
        'load',
        function () {
          resolve(reader.result)
        },
        false
      )
      reader.onerror = () => {
        // eslint-disable-next-line
        return reject(this);
        // eslint-enable-next-line
      }
      reader.readAsDataURL(blob)
    })
  },
  imgToBase64 (img) {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    canvas.width = img.width
    canvas.height = img.height
    ctx.drawImage(img, 0, 0)
    return canvas.toDataURL()
  }
}
